import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class ImportSalesBudgetResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {},
            errors: []
        }
    }
}
